import { render, staticRenderFns } from "./ReservesTableItems.vue?vue&type=template&id=189ad662&scoped=true&"
import script from "./ReservesTableItems.vue?vue&type=script&lang=ts&"
export * from "./ReservesTableItems.vue?vue&type=script&lang=ts&"
import style0 from "./ReservesTableItems.vue?vue&type=style&index=0&id=189ad662&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ad662",
  null
  
)

export default component.exports